import store from 'store2'
export default {
  data() {
    return {
      user_info: {}
    }
  },
  mounted() {
    this.user_info = JSON.parse(localStorage.getItem("user_info"));
  },
  methods: {
    // 跳转个人中心
    goInfo() {
      if (this.user_info.id) {
        this.$router.push({
          path: "/count_center/learning_record",
          query: {
            id: this.user_info.id
          },
        }).catch(err => {
          err
        });
      } else {
        this.logOut()
      }

    },
    // 退出登录
    logOut() {
      // store.clearAll()
      localStorage.removeItem('token')
      localStorage.removeItem('user_info')
      this.$router.replace('/login').catch(err => {
        err
      })
    },
    timeFormat(time) {
      // 转换为式分秒
      let h = parseInt(time / 60 / 60 % 24)
      h = h < 10 ? '0' + h : h
      let m = parseInt(time / 60 % 60)
      m = m < 10 ? '0' + m : m
      let s = parseInt(time % 60)
      s = s < 10 ? '0' + s : s
      // 作为返回值返回
      return [h, m, s]
    },
  },
}